const defaultState = true;
export default function(state = defaultState, action) {
    switch (action.type) {
        case 'USER_LOGIN':
        case 'FETCH_USER':
            return true;
        case 'USER_LOGIN_SUCCESS':
        case 'USER_LOGIN_ERROR':
        case 'FETCH_USER_SUCCESS':
        case 'FETCH_USER_ERROR':
            return false;
        default:
            return state;

    }
}
